import { Form } from '@form/Form';
import FormInput from '@form/FormInput';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../../hooks/useApi';
import { PermissionGroup } from '../types';

interface Props {
    clubSlug: string;
    permissionGroup?: PermissionGroup;
    callback: () => void;
}

export const PermissionGroupForm: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    clubSlug,
    permissionGroup,
    callback
}) => {
    const { t } = useTranslation('general');
    const [isLoading, setIsLoading] = useState(false);
    const api = useApi();

    const handleSubmit = (data: { title: string; description: string | null }) => {
        setIsLoading(true);
        return api({
            url: permissionGroup ? `permissionGroup/${permissionGroup.id}` : `club/${clubSlug}/permissionGroup`,
            method: permissionGroup ? 'PUT' : 'POST',
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: callback
        });
    };
    return (
        <Form onSubmit={handleSubmit} defaultValues={permissionGroup}>
            <FormInput name="title" label={t('permissions.groupForm.title')} />
            <FormInput.Textarea name="description" label={t('permissions.groupForm.description')} />
            <FormInput.Submit isLoading={isLoading} />
        </Form>
    );
};
